import { Navigate, useLocation } from "react-router-dom";

export function LegacyPromotionsRedirectPage({
  promoType,
}: {
  promoType: "2x1" | "3x2";
}) {
  const location = useLocation();

  return (
    <Navigate
      to={{
        pathname: "/promotions",
        search: `?promoType=${promoType}&from=legacy`,
      }}
      replace
      state={{ from: location.pathname }}
    />
  );
}
